<template>
    <v-col cols="12" xl="4" lg="3" md="6" id="metric-bar-b2b" class="box-container">
        <v-col cols="12" class="metric-title">
            <div class="d-flex flex-row">
                <div style="width: 90%;">
                    <span class="card-title" :title="metricInformation.title_graphic">{{metricInformation.title_graphic}}</span>
                </div>
                <div style="width: 10%;">
                    <span class="icon-info" @mouseleave="showBudget = false" @mouseover="showBudget = true" v-show="metricInformation.option.information">
                        <img src="/images/_SVGs/info.svg" onload="SVGInject(this)" width="20" height="20" />
                    </span>
                </div>
            </div>
        </v-col>
        <v-col cols="12" class="box-metric d-flex flex-column align-items-center">
            <v-chart
                ref="graphic_line"
                :options="metricInformation.option"
                class="graphic-resize"
            />
        </v-col>

        <v-card v-show="showBudget" class="card-info">
            <p>{{metricInformation.option.toolTipTitle}}</p>
            <div class="table-tooltip-info-metrics">
                <table>
                    <tr>
                        <td class="subinfo-info-tooltip-metrics">{{metricInformation.option.information}}</td>
                    </tr>
                </table>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    export default {
        props: {
            metricInformation: Array | Object
        },
        data(){
            return {
                showBudget: false,
            }
        },
        created() {
            window.addEventListener("resize", this.myEventHandler);
        },
        methods: {
            myEventHandler(e) {
                let myChart = this.$refs.graphic_line;
                if(myChart) {
                    myChart.resize();
                }
            },
            totalSum() {
                if(this.metricInformation) {
                    let getArrayNumbers = this.metricInformation.option.series[0].data;
                    if(getArrayNumbers.length > 0) {
                        getArrayNumbers = getArrayNumbers.map(e => Number(e));
                        const initialValue = 0;
                        return getArrayNumbers.reduce((previousValue, currentValue) => previousValue + currentValue, initialValue);
                    } else {
                        return '0';
                    }
                }
                return '0';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@sass/_variables.scss';
    .card-title {
        width: 95%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0;
    }

    #metric-bar-b2b {
        .graphic-resize{
            width: 100%;
            height: 100%;
        }
        .icon-info {
            margin-top: 2px;
            margin-right: 2px;
            display: flex;
            justify-content: flex-end;
        }
        .box-container {
            position: relative;
        }
        .metric-title {
            background-color: var(--v-primary-base);
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            text-align: center;
            padding: 3px;
            span {
                color: white;
                font-size: 11px;
                text-transform: uppercase;
            }
            i {
                color: white;
                cursor: pointer;
            }
        }
        .box-metric {
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #4B4849;
            height: 220px;
            span {
                color: #4B4849;
                letter-spacing: 0px;
                font-size: 30px;
            }

            p {
                color: #4B4849;
                letter-spacing: 0px;
                font-size: 12px;
            }
        }
        .box-metric-graphic {
            position: relative;
            border-bottom: 2px solid #4B4849;
            height: 210px;
            padding: 0;
        }
        .card-info {
            position: absolute;
            top: 50px;
            right: 0px;
            bottom: auto;
            width: 200px;
            z-index: 999;

            p {
                background-color: #D6D6D6;
                text-align: center;
                font-size: 14px;
                border-bottom: 1px solid #D6D6D6;
                color: #4B4849;
                padding: 5px;
            }

            .table-tooltip-info-metrics {
                margin-bottom: 16px;
                table {
                    .subinfo-info-tooltip-metrics {
                        font-size: 12px;
                        letter-spacing: 0px;
                        color: #4B4849;
                        opacity: 1;
                        padding-left: 10px;
                        padding-right: 5px;
                    }
                }
            }
        }
    }
</style>
